import { api } from './client';

export type ResetPeriod = 'NEVER' | 'YEAR' | 'MONTH';

export interface NumberScheme {
  id: string;
  document_type: string;
  organization_id: string | null;
  prefix: string;
  include_year: boolean;
  include_month: boolean;
  include_org_code: boolean;
  counter_width: number;
  separator: string;
  reset_period: ResetPeriod;
  per_organization: boolean;
  is_active: boolean;
}

export interface NumberSchemeCreate {
  document_type: string;
  organization_id?: string | null;
  prefix?: string;
  include_year?: boolean;
  include_month?: boolean;
  include_org_code?: boolean;
  counter_width?: number;
  separator?: string;
  reset_period?: ResetPeriod;
  per_organization?: boolean;
  is_active?: boolean;
}

export interface NumberPreview {
  document_type: string;
  organization_id: string | null;
  preview: string;
}

export const numberSchemes = {
  listDocumentTypes: () =>
    api.get<string[]>('/number-schemes/document-types').then((r) => r.data),
  defaultPrefixes: () =>
    api.get<Record<string, string>>('/number-schemes/default-prefixes').then((r) => r.data),
  list: (params?: { document_type?: string; organization_id?: string }) =>
    api.get<NumberScheme[]>('/number-schemes', { params }).then((r) => r.data),
  create: (p: NumberSchemeCreate) =>
    api.post<NumberScheme>('/number-schemes', p).then((r) => r.data),
  update: (id: string, p: Partial<NumberSchemeCreate>) =>
    api.patch<NumberScheme>(`/number-schemes/${id}`, p).then((r) => r.data),
  remove: (id: string) =>
    api.delete(`/number-schemes/${id}`).then(() => undefined),
  preview: (params: { document_type: string; organization_id?: string }) =>
    api.get<NumberPreview>('/number-schemes/preview', { params }).then((r) => r.data),
};
